import firebase from 'gatsby-plugin-firebase'

import { Creators } from '~/state/firebase/actions'
import metaTypes from '~/state/firebase/metaTypes'

import { store } from '../../../wrap-with-provider'
import getLocale from '../getLocale'

async function getLabelsFromFirestore(doc) {
  const labels = await firebase
    .firestore()
    .collection('Application')
    .doc('Assets')
    .collection('Labels')
    .doc(doc)

  return labels
}

export async function listenToLabels() {
  const locale = getLocale()
  let ref = await getLabelsFromFirestore(locale)
  const snap = await ref.get()

  // if (!snap.exists) {
  ref = await getLabelsFromFirestore('en')
  // }

  return store.dispatch(Creators.firebaseListenRequested(ref, metaTypes.labels))
}

export function removeLabelsListener() {
  return store.dispatch(
    Creators.firebaseRemoveListenerRequested(false, metaTypes.labels),
  )
}
